module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "app_container role_management"
  }, [_c('header-bar'), _vm._v(" "), _c('div', {
    staticClass: "app_content cl"
  }, [_c('div', {
    staticClass: "l content_left"
  }, [_c('left-menu', {
    attrs: {
      "active": _vm.active
    }
  })], 1), _vm._v(" "), _c('router-view')], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9ea6bd42", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ea6bd42","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/index/Index.vue
// module id = 172
// module chunks = 0